/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otaupdatebtninstall3Inputs */



/**
* | output |
* | --- |
* | "Install" |
*
* @param {Otaupdatebtninstall3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const otaupdatebtninstall3 = /** @type {((inputs?: Otaupdatebtninstall3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otaupdatebtninstall3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Install")
	if (locale === "es") return /** @type {LocalizedString} */ ("Instalar")
	return /** @type {LocalizedString} */ ("Установить")
});
export { otaupdatebtninstall3 as "otaUpdateBtnInstall" }